<div class="row page-header">
    <div class="col-12">
        <h1>Parts &amp; Fluids <small>(Beta) Equipment parts, fluids, filters, and tire sizes</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mb-3" (activeIdChange)="tabChanged()">
        @for (compartment of fluidCompartments; track compartment; let i = $index) {
            <li [ngbNavItem]="i + 1" [destroyOnHide]="false">
                <a ngbNavLink>{{ compartment }}</a>
                <ng-template ngbNavContent>
                    <app-fluid-capacity-list
                        [compartment]="compartment"
                        [canEdit]="canEdit"
                        [equipmentOptions]="equipmentOptions"
                        [equipmentDataMap]="equipmentDataMap"
                        [allItems]="fluidCapacities"
                        [parent]="equipmentContext"
                    ></app-fluid-capacity-list>
                </ng-template>
            </li>
        }
        <li [ngbNavItem]="10" [destroyOnHide]="false">
            <a ngbNavLink>GET</a>
            <ng-template ngbNavContent>
                <app-equipment-get-list
                    [canEdit]="canEdit"
                    [equipmentOptions]="equipmentOptions"
                    [equipmentDataMap]="equipmentDataMap"
                    [allItems]="equipmentGets"
                    [parent]="equipmentContext"
                ></app-equipment-get-list>
            </ng-template>
        </li>
        <li [ngbNavItem]="11" [destroyOnHide]="false">
            <a ngbNavLink>Battery Size</a>
            <ng-template ngbNavContent>
                <app-equipment-battery-list
                    [canEdit]="canEdit"
                    [equipmentOptions]="equipmentOptions"
                    [equipmentDataMap]="equipmentDataMap"
                    [allItems]="equipmentBatteries"
                    [parent]="equipmentContext"
                ></app-equipment-battery-list>
            </ng-template>
        </li>
        <li [ngbNavItem]="12" [destroyOnHide]="false">
            <a ngbNavLink>Brakes</a>
            <ng-template ngbNavContent>
                <app-equipment-brakes-list
                    [canEdit]="canEdit"
                    [equipmentOptions]="equipmentOptions"
                    [equipmentDataMap]="equipmentDataMap"
                    [allItems]="equipmentBrakes"
                    [parent]="equipmentContext"
                ></app-equipment-brakes-list>
            </ng-template>
        </li>
        <li [ngbNavItem]="13" [destroyOnHide]="false">
            <a ngbNavLink>Filters</a>
            <ng-template ngbNavContent>
                <app-equipment-filter-list
                    [canEdit]="canEdit"
                    [equipmentOptions]="equipmentOptions"
                    [equipmentDataMap]="equipmentDataMap"
                    [allItems]="equipmentFilters"
                    [parent]="equipmentContext"
                ></app-equipment-filter-list>
            </ng-template>
        </li>
        <li [ngbNavItem]="14" [destroyOnHide]="false">
            <a ngbNavLink>Tire/Track Size</a>
            <ng-template ngbNavContent>
                <app-equipment-tire-config-list
                    [canEdit]="canEdit"
                    [equipmentOptions]="equipmentOptions"
                    [equipmentDataMap]="equipmentDataMap"
                    [allItems]="equipmentTireConfigs"
                    [parent]="equipmentContext"
                ></app-equipment-tire-config-list>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>
